import React, { useState, useEffect, useRef } from "react";
import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import axios from "axios";
import moment from "moment";
import ValidarUsuario from "../comun/modalValidarUsuario";
import { ModalFondoAvance } from "./modalFondoAvance";
import { formatMoneda } from "../../util/varios";
import { PrimaryButton } from "../../ui/buttons/Button";
import { Input } from "../../ui/inputs/Input";

const TablaFondoAvance = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CÓDIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CONCEPTO",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [moviBanco, setMoviBanco] = useState(null);
  const [egreso, setEgreso] = useState();
  const [egresoDetalle, setEgresoDetalle] = useState();
  const [gastos] = useState([]);
  const [datos] = useState();
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [values, setValues] = useState({});
  const [detalles, setDetalles] = useState({});
  const [asignacion, setAsignacion] = useState({});

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            // Iterar sobre las propiedades del objeto x
            for (let prop in x) {
              // Verificar si la propiedad es una cadena y si incluye el valor de búsqueda
              if (
                typeof x[prop] === "string" &&
                x[prop].toLowerCase().includes(target.value.toLowerCase())
              ) {
                return true;
              }
            }
            return false;
          });
        }
      },
    });
  };
  const seleccionarRegistros = () => {
    setMostrar2(false);
    let campos = "*";
    let nomtab = "fondoavance";
    let nomid = "idefiscal";
    let condic = true;
    let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarEgreso = (id, ope) => {
    let campos = "*";
    let nomtab = "chequeemitido";
    let nomid = "idchequeemitido";
    let condic = "idefiscal = " + idefiscal;
    let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data[0].idchequeemitido > 0) {
            setEgreso(response.data);
            if (ope === 2 || ope === 3) {
              seleccionarMovimientosCheque(id, ope);
            } else {
              seleccionarEgresoDetalle(id);
            }
          } else {
            setEgreso();
            setEgresoDetalle();
            setMoviBanco();
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarEgresoDetalle = (id) => {
    let endpoint = `${op.conexion}/api/administracion/registrochequesemitidodetalle?efi=${idefiscal}&idcheemi=${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setEgresoDetalle(response.data);
            setMostrar2(true);
          } else {
            setEgresoDetalle();
            setMostrar2(true);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarMovimientosCheque = (id, ope) => {
    let endpoint = `${op.conexion}/api/administracion/seleccionarmovimientosbancocheque?idcheque=${id}&idefi=${idefiscal}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idmovimientobanco > 0) {
            if (ope === 2 && response.data.movconciliado === true) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto:
                  "El Egreso Tiene el Movimiento Conciliado \n con Fecha de Conciliación: " +
                  moment.utc(response.data.fechaconci).format("DD/MM/YYYY") +
                  "\n" +
                  "Debe notificarlo a Tesoreria",
                icono: "error",
              });
              setActivate(false);
              return;
            } else if (ope === 2 && response.data.condepo === true) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto:
                  "El Egreso fue depositado en la Cuenta de Fondo de Terceros" +
                  "\n" +
                  "Debe reversar el Deposito",
                icono: "error",
              });
              setActivate(false);
              return;
            }
            setMoviBanco(response.data);
            seleccionarEgresoDetalle(id);
          } else {
            setMoviBanco();
            seleccionarEgresoDetalle(id);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
  };

  const seleccionarDetalles = (data) => {
    setMostrar2(false);
    let endpoint = `${op.conexion}/api/administracion/historicopagosfondo?espiritu=${espiritu}&id=${data.idfondo}`;
    setActivate(true);
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data) {
            setDetalles(response.data);
          } else {
            setDetalles([]);
          }
          seleccionarAsignaciones(data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const gestionar = (op, data) => (e) => {
    setOperacion(op);
    if (op === 1) {
      setMostrar2(true);
      setDetalles();
      setAsignacion();
    } else {
      seleccionarDetalles(data);
    }
  };
  useEffect(() => {
    seleccionarRegistros();
    setActivate(true);
  }, []);
  const handleCancelar = () => {
    setEgreso();
    setEgresoDetalle();
    setMostrar2(false);
  };
  const cerrar = () => {
    props.setTabla(0);
  };
  const aceptaClaveSupervisor = () => {
    setMostrarUsuario(false);
    setOperacion(3);
    seleccionarEgreso(datos.idchequeemitido, 3);
  };
  const seleccionarAsignaciones = (data) => {
    let campos = "*";
    let nomtab = "aumentofondoavance";
    let condi = `idfondo = ${parseInt(
      data.idfondo
    )} and idefiscal = ${idefiscal}`;
    let orden = "idaumentofondoavance";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (data.tabla === 1) {
            setAsignacion(response.data);
          } else {
            if (response.data) {
              setAsignacion(response.data);
              setValues(data);
              setMostrar2(true);
            } else {
              setAsignacion([]);
              setValues(data);
              setMostrar2(true);
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  return (
    <div className="col-8 m-0 p-0 mx-auto mt-5">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant roundes-top text-light">
        <h3 className="m-0">Fondo en Avances</h3>
        <a onClick={cerrar}>
          salir<i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <form onSubmit={(e)=>{e.preventDefault()}} 
      className="col-12 m-0 p-2 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
          <Input
            ref={txtBuscador}
            onChange={handleSearch}
            placeholder="Buscar"
          />
        </div>
        <PrimaryButton icon = 'fa-plus m-0'
          onClick={gestionar(1, "")}
        >
        </PrimaryButton>
      </form>
      <div>
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "30px",
                    }}
                  >
                    {item.idfondo}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "300px",
                    }}
                  >
                    {item.descripcion}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                    }}
                  >
                    {formatMoneda(
                      item.monto
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "100px",
                    }}
                  >
                    <button
                      onClick={gestionar(4, item)}
                      className="btn btn-sm mx-1 btn-info rounded-circle"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                    <button
                      onClick={gestionar(2, item)}
                      className="btn btn-sm mx-1 btn-warning rounded-pill"
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <button
                      onClick={gestionar(3, item)}
                      className="btn btn-sm mx-1 btn-danger rounded-pill"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ModalFondoAvance
        show={mostrar2}
        gastos={gastos}
        operacion={operacion}
        movibanco={moviBanco}
        egreso={egreso}
        egresodetalle={egresoDetalle}
        onHideCancelar={handleCancelar}
        onHideRenderizar={seleccionarRegistros}
        values={values}
        detalles={detalles}
        asignacion={asignacion}
        renderAsig={seleccionarAsignaciones}
      />
      <ValidarUsuario
        show={mostrarUsuario}
        onHideCancela={() => {
          setMostrarUsuario(false);
        }}
        onHideConfirmar={aceptaClaveSupervisor}
        llamado={1}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};
export default TablaFondoAvance;
